import type {
  DeclarePlatformStockInput,
  PlatformStock,
  PlatformStockImportResult,
} from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const declarePlatformStock = async (data: DeclarePlatformStockInput) => {
  const response = await gozokiApiWithAuth.post<PlatformStock>('/platform-stocks', data)
  return response.data
}

export const deletePlatformStock = async (id: number) => {
  await gozokiApiWithAuth.delete(`/platform-stocks/${id}`)
}

export const deletePlatformStockLog = async (id: number) => {
  await gozokiApiWithAuth.delete(`/platform-stock-logs/${id}`)
}

export const revertPlatformStockLog = async (id: number) => {
  await gozokiApiWithAuth.post(`/platform-stock-logs/${id}/revert`)
}

export const exportPlatformStocks = async (params: {
  storeReference?: string
  internalCategoryIds?: number[]
}) => {
  const response = await gozokiApiWithAuth.get<Blob>('/platform-stocks/export', {
    params,
    responseType: 'blob',
  })
  return response.data
}

export const importPlatformStocks = async (file: File) => {
  const formData = new FormData()
  formData.append('importFile', file)
  const response = await gozokiApiWithAuth.post<PlatformStockImportResult>(
    '/platform-stocks/import',
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  )
  return response.data
}
